/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type createClosetSectionMutationVariables = {
  poshmarkUserId: string;
  name: string;
};
export type createClosetSectionMutationResponse = {
  readonly superposherCreateClosetSection: {
    readonly success: boolean;
  };
};
export type createClosetSectionMutation = {
  readonly response: createClosetSectionMutationResponse;
  readonly variables: createClosetSectionMutationVariables;
};

/*
mutation createClosetSectionMutation(
  $poshmarkUserId: String!
  $name: String!
) {
  superposherCreateClosetSection(poshmarkUserId: $poshmarkUserId, name: $name) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'name',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'poshmarkUserId',
    },
    v2 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'name',
            variableName: 'name',
          },
          {
            kind: 'Variable',
            name: 'poshmarkUserId',
            variableName: 'poshmarkUserId',
          },
        ],
        concreteType: 'SuperposherCreateClosetSectionResponse',
        kind: 'LinkedField',
        name: 'superposherCreateClosetSection',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'createClosetSectionMutation',
      selections: v2 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v1 /*: any*/, v0 /*: any*/],
      kind: 'Operation',
      name: 'createClosetSectionMutation',
      selections: v2 /*: any*/,
    },
    params: {
      cacheID: 'c7a28646e76043fbf497f8409ac01be7',
      id: null,
      metadata: {},
      name: 'createClosetSectionMutation',
      operationKind: 'mutation',
      text: 'mutation createClosetSectionMutation(\n  $poshmarkUserId: String!\n  $name: String!\n) {\n  superposherCreateClosetSection(poshmarkUserId: $poshmarkUserId, name: $name) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = '913fdab927dad2e611440f7adab224fa';
export default node;
